module.exports = __webpack_public_path__ + "img/user-nurse-duotone.c0f209e2.svg";